// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './st... Remove this comment to see the full error message
import { start } from './start';
start();